<template>
  <div>
    <div class="flex-container">
      <div class="item menu-container">
        <the-menu></the-menu>
      </div>
      <div class="item main-container m-hide">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import TheMenu from "@/components/Menu/TheMenu";
import store from '@/store'
import { getCookie } from "@/utils";
export default {
  components: { TheMenu },

  beforeRouteEnter (to, from, next) {
    const requests = []
    requests.push(store.dispatch('featchSettingTimer'))
    requests.push(store.dispatch('common/fetchAllProCompanies'))
    requests.push(store.dispatch('common/fetchAllAdmCodeDetail'))
    requests.push(store.dispatch('common/fetchAllSystemParam'))
    requests.push(store.dispatch('common/fetchCountry'))
    requests.push(store.dispatch('common/fetchJobs'))
    requests.push(store.dispatch('common/fetchAddress'))
    Promise.all(requests).then(r => {
      if (process.env.NODE_ENV !== 'production') {
        console.log('common data fetch success')
      }
      next()
    })
  },

  created() {
    this.$api.get("/public/getVer");
  },

  mounted() {
    let xsrft = getCookie("!Proxy!RestApiProxyXSRF-TOKEN");
    if (!xsrft) {
      xsrft = getCookie("XSRF-TOKEN");
    }
    const request = new XMLHttpRequest();
    const url = this.$api.defaults.baseURL + "/logout";
    window.onbeforeunload = (e) => {
      //this.$store.dispatch('user/logout', { isWait: 'Y' })  非同步寫法
      //   //只能用同步的api寫法
      /*
      //   另一種寫法
      request.open('POST', 'http://localhost:8080/RestApi/logout', false)
      request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded')
      request.setRequestHeader('X-XSRF-TOKEN', xsrft)
      request.setRequestHeader('keepalive', true)
      request.send('isWait=Y')
      */
      fetch(url, {
        method: "POST",
        headers: {
          "Content-type": "application/x-www-form-urlencoded",
          "X-XSRF-TOKEN": xsrft,
        },
        body: "isWait=Y",
        keepalive: true,
      });
    };
    // this.$api.get('/public/getVer')
    /*
    window.addEventListener('beforeunload', (e) => {
      this.$store.dispatch('user/logout', { isWait: 'Y' })
    })
    */
  },
};
</script>
<style lang="stylus">
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.flex-container {
  display: flex;
}

.item {
  & + .item {
    margin-left: 30px;
  }
}

.menu-container {
  min-width: 250px;
}

.main-container {
  flex-grow: 2;
  flex-shrink: 1;
  padding-right: 30px;
  flex-basis: 0%;
  margin-top:30px;
  min-width: calc(100vw - 280px);
  margin-bottom:50px
}
@media (min-width: 1440px){
  .main-container {
    min-width: calc(100vw - 480px);
  }}
</style>
